import React, { useState, useCallback } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import s from "./ReactImageCrop.module.scss";
import { IconButton, Tooltip } from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

export default function ReactImageCrop(props) {
  const [upImg, setUpImg] = useState();
  const [imgRef, setImgRef] = useState(null);
  const [crop, setCrop] = useState({ unit: "px", width: 50, height: 50 });
  const [previewUrl, setPreviewUrl] = useState();

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onLoad = useCallback((img) => {
    setImgRef(img);
  }, []);

  const makeClientCrop = async (crop) => {
    if (imgRef && crop.width && crop.height) {
      // createCropPreview(imgRef, crop, "newFile.jpeg");
      const croppedImageUrl = await createCropPreview(
        imgRef,
        crop,
        "newFile.jpeg"
      );
      console.log("Image Url : ", croppedImageUrl);
      setPreviewUrl(croppedImageUrl);
      props.updatePreviewUrl(croppedImageUrl);
      // this.setState({ croppedImageUrl });
      // createCropPreview(imgRef, crop, "newFile.jpeg");
    }
  };

  const createCropPreview = async (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // canvas.width = crop.width;
    // canvas.height = crop.height;
    canvas.width = Math.ceil(crop.width * scaleX);
    canvas.height = Math.ceil(crop.height * scaleY);
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          blob.name = fileName;
          window.URL.revokeObjectURL(previewUrl);
          resolve(window.URL.createObjectURL(blob));
          // setPreviewUrl(window.URL.createObjectURL(blob));
          // props.updatePreviewUrl(window.URL.createObjectURL(blob));
        },
        "image/jpeg",
        1
      );
    });
  };

  return (
    <div className={s.container}>
      <ReactCrop
        className={s.reactCropContainer}
        src={upImg}
        onImageLoaded={onLoad}
        crop={crop}
        onChange={(c) => setCrop(c)}
        onComplete={makeClientCrop}
      />
      <section className={s.actionsContainer}>
        <section className={s.previewContainer}>
          {previewUrl && <span>Preview :</span>}
          {previewUrl && (
            <div className={s.previewImage}>
              <img alt="Crop preview" src={previewUrl} />
            </div>
          )}
        </section>
        <div className={s.inputContainer}>
          <input
            accept="image/*"
            style={{ display: "none" }}
            onChange={onSelectFile}
            id="icon-button-file"
            type="file"
          />
          <label htmlFor="icon-button-file">
            <IconButton aria-label="upload picture" component="span">
              <Tooltip title="Upload Picture" aria-label="Upload Picture">
                <PhotoCamera />
              </Tooltip>
            </IconButton>
          </label>
        </div>
      </section>
    </div>
  );
}
